import React, { useState } from 'react';

import GlobalCompanyDrawer from 'app/components/Drawers/GlobalCompany/GlobalCompanyDrawer';
import { getCompanyLogoUrl } from 'utils';

import SideDrawer from '../SideDrawer';
import { CompanyLogoContainer, CompanyLogoEmpty } from './styled';

interface CompanyLogoProps {
  size: number;
  slug: string;
  borderColor?: string;
  additionalStyle?: React.CSSProperties;
  onClick?: () => void;
  useRounded?: boolean;
  backgroundColor?: string;
  onErrorComponent?: JSX.Element;
  openDrawer?: boolean;
  stopPropagation?: boolean;
}

export default function CompanyLogo({
  size,
  slug,
  borderColor,
  additionalStyle = {},
  onClick = null,
  useRounded = false,
  backgroundColor = '#FFFFFF',
  onErrorComponent = null,
  openDrawer = false,
  stopPropagation = true,
}: CompanyLogoProps) {
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const logoSrc = useRounded
    ? `/images/logos/rounded_kyu_companies/${slug}.svg`
    : getCompanyLogoUrl(slug);
  const [failedLogoSrc, setFailedLogoSrc] = useState<string | null>(null);

  const handleOpenDrawer = () => {
    setShowDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  const handleClick = (e: React.MouseEvent<HTMLImageElement | HTMLDivElement, MouseEvent>) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    if (openDrawer) {
      handleOpenDrawer();
    } else {
      onClick?.();
    }
  };

  const isClickable = openDrawer || onClick !== null;

  if (['pencil-and-paper'].includes(slug)) {
    return (
      <CompanyLogoEmpty
        size={size}
        style={additionalStyle}
        borderColor={borderColor}
        onClick={isClickable ? (e) => handleClick(e) : undefined}
        backgroundColor={backgroundColor}
      />
    );
  }

  return (
    <>
      {failedLogoSrc === logoSrc ? (
        onErrorComponent
      ) : (
        <CompanyLogoContainer
          src={logoSrc}
          data-id="company-logo"
          size={size}
          style={additionalStyle}
          borderColor={borderColor}
          onClick={isClickable ? (e) => handleClick(e) : undefined}
          backgroundColor={backgroundColor}
          data-slug={slug}
          loading="lazy"
          onError={() => setFailedLogoSrc(logoSrc)}
        />
      )}
      {showDrawer ? (
        <SideDrawer closeDrawer={handleCloseDrawer} withClose>
          <GlobalCompanyDrawer slug={slug} />
        </SideDrawer>
      ) : null}
    </>
  );
}
